import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { serialise } from "kitsu-core";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { UserDeviceVariables } from "./types";
import { userKeys } from "./utils";

export const useCreateUserDevice = (
  options?: UseMutationOptions<void, PortalAxiosError, UserDeviceVariables>
) => {
  const server = useServer();

  return useMutation<void, PortalAxiosError, UserDeviceVariables>(
    userKeys.devices,
    (variables) =>
      server.post("user/devices", serialise("user_device", variables)),
    options
  );
};

export default useCreateUserDevice;
